export default __webpack_public_path__ + "static/927-736c7dacd0b73c48d6735f7b640664e9.gif";